import { get, patch, post, destroy } from './httpClient'

export const addTax = (body) => post('/tax/create', body)
export const getTaxList = (query) => get('/tax', query)
export const updateTax = (body, id) => patch(`/tax/update/${id}`, body)
export const deleteTax = (ids) => destroy('/tax/delete', { tax_id: ids })
export const getServiceFee = (query) => get('/tax/service-fee', query)
export const addServiceFee = (body) => post('/tax/service-fee/create', body)
export const updateServiceFee = (body, id) => patch('/tax/service-fee/update/' + id, body)
export const deleteServiceFee = (body) => destroy('/tax/service-fee/delete', body)
